const schoolShifts = {
  form: {
    general: {
      header: 'General', 
      fields: {
        students: {
          label: 'Select Students',
        }
      }
    },
    details: {
      header: 'Details',
      fields: {
        direction:{
          label: 'Direction',
        },
        shift: {
          label: 'School Hours',
        },
        from: 'From',
        to: 'To',
        fromDate: {
          label: 'From Date'
        },
        toDate: {
          label: 'To Date',
        },
        weekDays: 'Weekdays',
        fromHour: {
          label: 'School Starts at',
        },
        reqPick: {
          label: 'Requested Pickup Time',
        },
        toHour: {
          label: 'School Ends at',
        },
      },
    },
  },
  select: 'Select',
  direction: {
    collect: {
      templates: {
        default: 'Collect',
        schoolShuttles: 'To School',
        trailers: 'Collect',
      },
    },
    distribute: {
      templates: {
        default: 'Distribute',
        schoolShuttles: 'From School',
        trailers: 'Distribute',
      },
    },
    collectAndDistribute: {
      templates: {
        default: 'Collect/Distribute',
        schoolShuttles: 'To School / From School',
        trailers: 'Collect/Distribute',
      },
    },
  }
};

export default schoolShifts;